import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * ترکیب کلاس‌های Tailwind با حل تعارض.
 *
 * `clsx` شرط‌ها را جمع می‌کند و `twMerge` تعارض را حل می‌کند: در
 * `cn('p-2', 'p-4')` نتیجه `p-4` است، نه هر دو. بدون `twMerge`، override کردن
 * کلاس یک جزء از بیرون به ترتیب تولید CSS وابسته می‌شد که غیرقابل پیش‌بینی است.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs))
